import { Unit } from 'webapp/enums/enums';

import didInsert from 'webapp/modifiers/did-insert';
import didUpdate from 'webapp/modifiers/did-update';
import FormSelectComponent from 'webapp/components/form/select';
import type { ArgsSingle as BaseArgs, Options } from 'webapp/components/form/select-attributes';
import FormSelectAttributesComponent from 'webapp/components/form/select-attributes';

export const GetItemsMethodName = 'getUnits';
export const HasItemsPropOnMk = 'hasUnits';
export const HasItemsPropOnMetricSetup = 'hasUnits';

interface Args extends BaseArgs {
	allowAllUnits?: boolean;
}

export default class FormSelectUnitsComponent extends FormSelectAttributesComponent<Args> {
	override get getItemsMethodName(): typeof GetItemsMethodName {
		return GetItemsMethodName;
	}

	override get hasItemsPropOnMk(): typeof HasItemsPropOnMk {
		return HasItemsPropOnMk;
	}

	override get hasItemsPropOnMetricSetup(): typeof HasItemsPropOnMetricSetup {
		return HasItemsPropOnMetricSetup;
	}

	get allowAllUnits() {
		return this.args.allowAllUnits ?? true;
	}

	override get extraOptions() {
		const options: LabelValuePairString[] = [];

		if (this.allowAllUnits) {
			options.push({ value: Unit.ALL, label: 'All units' });
		}

		options.push({ value: Unit.EMPTY, label: 'No unit' });

		return options;
	}

	override get placeholder() {
		return this.args.placeholder || 'Select unit';
	}

	override get floatlabelText() {
		return 'Unit';
	}

	override isOnList(item: string, list: Options) {
		if (!this.allowAllUnits && item === Unit.ALL) {
			return true; // don't add "all" if not allowed, even if is selected
		}
		return super.isOnList(item, list);
	}
	<template>
		<FormSelectComponent
			name={{this.uniqueId}}
			@selected={{this.selectedSingle}}
			@options={{this.options}}
			@onChange={{this.onChange}}
			@isNumeric={{false}}
			@isMultiple={{@isMultiple}}
			@placeholder={{this.placeholder}}
			@floatlabelText={{this.floatlabelText}}
			@maxSelectionLength={{@maxSelectionLength}}
			@isLoading={{this.isLoading}}
			@isDisabled={{@isDisabled}}
			@isRequired={{@isRequired}}
			@tooltipOnSelectionFromProperty=""
			@onCustomAdd={{this.onCustomAdd}}
			@onOpen={{this.onOpen}}
			@onClose={{this.onCloseSingle}}
			@beforeChange={{this.beforeChangeSingle}}
			@showFloatlabel={{@showFloatlabel}}
			@theme={{@theme}}
			@size={{@size}}
			{{didInsert this.setupView}}
			{{didUpdate this.onMetricChange @metricSetupForQuery.metric}}
			{{didUpdate this.onSelectedChange @selected}}
			{{didUpdate this.onPropChange @isMultiple @disabledItemsList}}
		/>
	</template>
}
